<template>
  <div class="animated fadeIn">
    <div class="row pageinfo">
      <b-col lg="6">
        <!--Display Trash or Normal Table View-->
        <h2 v-show="!trash">Indexes</h2>
        <h2 v-show="trash">Indexes - Trash</h2>
      </b-col>
    </div>

    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container index>
            <!-- Main table element -->
            <b-row class="justify-content-between">
              <b-col md="4" class="my-1">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <b-form-input v-model="filter" placeholder="Search" />
                    <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" class="my-1">
								<b-dropdown class="pull-left" :text="dpdt">
									<b-dropdown-item @click="trashIndex()">Active</b-dropdown-item>
									<b-dropdown-item @click="trashIndex()">Trash</b-dropdown-item>
								</b-dropdown>
							</b-col>
              <b-col lg="5" class="my-1">
                <b-button variant="primary" class="pull-right" @click="newIndexModal">Add Index</b-button>
              </b-col>
            </b-row>
            <b-row v-if="loadingData">
              <b-col cols="12" sm="12" md="12" lg="12">
                <p class="text-center">
                  <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
                </p>
              </b-col>
            </b-row>
            <!-- End Main table Elements-->
            <b-table v-else striped hover bordered show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered"  @row-clicked="rowClicked">

            </b-table>
            <b-row>
              <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"></div>
                  <b-select :options="pageOptions" v-model="perPage" />
                </div>
              </b-col>
              <!-- User Interface controls -->

              <b-col lg="10" md="10" sm="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- End User Interface controls-->
          </b-container>
        </b-row>
      </div>
    </div>
    <!-- New Index Modal-->
    <b-modal title="New Index" v-model="newIndex" ok-only ok-title="Cancel" ok-variant="secundary">
      <b-row>
        <b-col cols="12">
						<b-form-group :label-cols="4" horizontal label="Settle Date" label-for="settle_date">
							<b-form-input id="settle_date" v-model="model.settle_date" type="date"></b-form-input>
						</b-form-group>
          <b-form-group :label-cols="4" horizontal label="Fluid Type" label-for="fluid_type">
							<b-form-select :disabled="fluid_types.length == 0" value-field="id" text-field="name" id="fluid_type" v-model="model.fluid_type_id" :options="fluid_types"/>
					</b-form-group>

						<b-form-group :label-cols="4" horizontal label="Index" label-for="index">
							<b-form-input id="index" v-model="model.index" type="text" @keydown.native="myOnlyNumber($event, 'rate')"></b-form-input>
						</b-form-group>
						<b-form-group :label-cols="4" horizontal label="WADF" label-for="wadf">
							<b-form-input id="wadf" v-model="model.wadf" type="number" @blur.native="coordsBlur('wadf')"></b-form-input>
						</b-form-group>
				</b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="newIndex=false" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="saveIndex" class="float-right">Save</b-btn>
      </div>
    </b-modal>
    <!-- End New Index Modal-->
    </div>
</template>

<script>
  import Vue from 'vue'
  import t_agreement from './t_agreement'
  import moment from 'moment';

  const items = []
  export default {
    name: 'Index',
    created: function() {
      this.getAll()
    },
    data() {
      return {
        trash       : false,
        dpdt        : 'Active',
        fluid_types : [],
        model       : {
          fluid_type_id : null,
          settle_date   : null,
          index         : null,
          wadf          : null
        },

        newIndex    : false,
        items       : items,
        fields      : [
          {
            key: 'id',
            label: 'ID',
            sortable: true
          },
          {
            key: 'settle_date',
            label: 'Settle Date',
            sortable: true,
            formatter: (value) => { return moment(value).format("MMM DD, YYYY") }
          },
          {
            key: 'fluid_type',
            label: 'Fluid Type',
            sortable: true
          },
          {
            key: 'index',
            label: 'Index',
            sortable: true,
            formatter: (value) => { if (value!='<b-col class ="value_none" ><b>None</b></b-col>') {return '$'+value} else {return value}}
          },
          {
            key: 'wadf',
            label: 'WADF',
            sortable: true,
            formatter: (value) => { if (value!='<b-col class ="value_none" ><b>None</b></b-col>') {return '$'+value} else {return value}}
          }
        ],
        currentPage : 1,
        perPage     : 25,
        totalRows   : items.length,
        pageOptions : [25, 50, 100],
        sortBy      : 'id',
        sortDesc    : false,
        filter      : null,
        loadingData : true,
        savebtn     :true,
        rate        : '',
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })
      }
    },
    methods: {
      myOnlyNumber(evt, variableName) {
					let dotPosition = this[variableName].indexOf(".")
					let hasDot = dotPosition > -1
					let length = this[variableName].length
					this.isNumber(evt, hasDot, dotPosition, length)
				},
			isNumber: function(evt, hasDot, dotPosition, length) {
					evt = (evt) ? evt : window.event;
					var charCode = (evt.which) ? evt.which : evt.keyCode;
					if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
					// if (charCode <= 31 || charCode == 37 || charCode == 39 || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190))) {
						let selectionStart = evt.target.selectionStart;
						let selectionEnd = evt.target.selectionEnd;
						if ((hasDot && selectionEnd > dotPosition && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
							evt.preventDefault();
						} else {
							return true
						}
					} else {
						evt.preventDefault();
					}
			},
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      newIndexModal() {
				this.model = {
          fluid_type_id : null,
          settle_date   : null,
          index         : null,
          wadf          : null
				}
        this.savebtn=false
				this.newIndex = true
      },
      trashIndex() {
				this.trash = !this.trash
				this.dpdt = this.trash ? "Trash" : "Active"
				this.getAll()
				this.loadingData = true
			},
      rowClicked(row) {
				if(!this.trash) {
					this.$router.push('/index/' + row.id + '/')
				} else {
					this.restoreIndex(row.id)
				}
      },
      okToSave() {

        	if(this.model.settle_date == null) {
						this.$swal('Alert!', 'Settle Date not selected', 'warning')
						return false
					} else if(this.model.fluid_type_id == null) {
						this.$swal('Alert!', 'Fluid Type not selected', 'warning')
						return false
					} else if(this.model.index == null) {
						this.$swal('Alert!', 'Index cannot be empty', 'warning')
						return false
					} else if(this.model.wadf == null) {
						this.$swal('Alert!', 'WADF cannot be empty', 'warning')
						return false
          }
				return true
			},
      saveIndex () {
        if (!this.okToSave()) {
					return
				}
        this.savebtn=true
        t_agreement.save_indexes(this.model)
          .then(data => {
            this.$swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.newIndex = false
                  this.getAll()
                }
              })
          })
          .catch(error => {
            this.$swal('Error', 'Server not response. ' + error, 'error')
          })
          this.savebtn=false
      },
      getAll() {
        this.loadingData = true
        t_agreement.get_indexes()
          .then(data => {
            if (data.status == 'success') {
              this.items        = data.indexes.filter(o => o.status_id == (this.trash ? 2 : 1))
              this.fluid_types  = data.insert_data.fluid_types
            }else {
              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      restoreIndex(id) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to restore this Index?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
          reverseButtons: true
				}).then((result) => {
					if (result.value) {
						t_agreement.restoreIndex(id)
							.then(data => {
                this.$swal(data.status, data.message, data.status)
								if (data.status == 'success') {
									this.filter = ''
									this.trash = false
									this.getAll()
                  this.loadingData = true
                  this.dpdt = 'Active'
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			coordsBlur(variableName) {
				if(this.model[variableName] !== undefined) {
					let x = String(this.model[variableName]).split(".")
					if(x.length == 1 && x[0].length == 0) {
						this.model[variableName] = '0.00'
					} else if(x.length == 1) {
						this.model[variableName] = this.model[variableName] + '.00'
					} else {
						this.model[variableName] = x[0] + "." + x[1]
						this.model[variableName] = parseFloat(parseFloat(String(this.model[variableName])))
					}
				}
			},
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/terminal_agreements/indexes.vue